
import { Vue, Component, Prop } from "vue-property-decorator"

@Component
export default class AppPage extends Vue {
  @Prop({ required: true })
  readonly title!: string
}
